import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Creators as requestStatusActions } from '../../../../../../../domain/useCases/procedures/getStudentProcedureStatus';
import { Creators as cancelActions } from '../../../../../../../domain/useCases/procedures/UpdatePhoto/cancelUseCase';
import constants from '../../../../constants';
import routes from '../../../../../../components/Routes/routingMap';
import RetirementOfPeriodProgressView from './RetirementPeriodProgressView';

const RetirementOfPeriodProgressViewController: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { requestId } = useSelector(
    (state: any) => state.registerRetirementOfPeriod
  );

  const { procedure, request, isLoading, isComplete, isApproved } = useSelector(
    (state: any) => state.procedureStudentStatus
  );
  const { isLoading: isLoadingCancel, isSuccess: isSuccessCancel } =
    useSelector((state: any) => state.cancelUpdatePhoto);

  useEffect(() => {
    if (requestId) {
      dispatch(
        requestStatusActions.getStudentProcedureStatus(
          constants.categories.requests.procedures.removeOfPeriod,
          requestId
        )
      );
    }
  }, []);
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const handleCancelRetirementOfPeriod = (requestIdParam: number) => {
    dispatch(
      cancelActions.cancelUpdatePhoto(
        requestIdParam,
        constants.categories.requests.procedures.removeOfPeriod
      )
    );
  };

  useEffect(() => {
    if (isSuccessCancel) {
      history.push(routes.student.procedures.home);
    }
  }, [isSuccessCancel]);

  const handleBack = () => history.push(routes.student.procedures.home);
  const handleNullationRequest = () => setShowCancelConfirm(true);
  const handleCloseModalConfirmation = () => setShowCancelConfirm(false);
  const handleNullationModalConfirmation = () =>
    handleCancelRetirementOfPeriod(request?.id);

  useEffect(() => {
    if (request?.status?.name === 'Procede') {
      history.push(
        `${
          routes.student.procedures.categories.requests.retirementperiod
            .procedureprogress
        }${'?status=finalizado'}`
      );
    }
    if (request?.status?.name === 'No procede') {
      history.push(
        `${
          routes.student.procedures.categories.requests.retirementperiod
            .procedureprogress
        }${'?status=Finalizadonoprocede'}`
      );
    }
  }, [request]);

  return (
    <RetirementOfPeriodProgressView
      procedure={procedure}
      request={request}
      isComplete={isComplete}
      isApproved={isApproved}
      handleBack={handleBack}
      isLoading={isLoading}
      isLoadingCancel={isLoadingCancel}
      handleNullationRequest={handleNullationRequest}
      handleNullationModalConfirmation={handleNullationModalConfirmation}
      handleCloseModalConfirmation={handleCloseModalConfirmation}
      showModalConfirmation={showCancelConfirm && !isLoadingCancel}
    />
  );
};

export default RetirementOfPeriodProgressViewController;
